import { RootStore } from 'stores/pet-profile-new/types';
import { getCustomerKey } from 'stores/pet-profile-new/utils/get-customer-key';
import { PetProfile } from 'types/pet-profile';

interface MergePetProfiles {
  store: RootStore;
  petProfile: PetProfile;
}

/**
 * Adds petProfile to the provided store.
 * In case it finds pet profile with the same id it will update it instead of adding.
 * Returns new object.
 */
export const mergePetProfiles = ({ store, petProfile }: MergePetProfiles): Partial<RootStore> => {
  const customerKey = getCustomerKey(store.customerId);
  const customerProfileIds = store.profilesPerCustomer[customerKey] ?? [];
  const hasProfile = customerProfileIds.includes(petProfile.id);

  return {
    petProfiles: hasProfile
      ? store.petProfiles.map((profile) => {
          return profile.id === petProfile.id ? petProfile : profile;
        })
      : [...store.petProfiles, petProfile],
    profilesPerCustomer: {
      ...store.profilesPerCustomer,
      [customerKey]: hasProfile ? customerProfileIds : [...customerProfileIds, petProfile.id],
    },
  } satisfies Partial<RootStore>;
};
